<template>
  <div>


<h2 class="goth" ref="gramtitel">Stark och svag böjning av adjektiv</h2><br>
<p class="grammatikparagrafbredd leftorient">I tyskan böjs ett adjektiv antingen</p>
<ul class="grammatikparagrafbredd leftorient">
    <li>inte alls</li>
    <li>starkt <i>eller </i></li>
    <li>svagt</li>
</ul>

<div class="grammatikparagrafbredd leftorient">
    <h4>böjs inte</h4>
    <p>Om ett adjektiv står som <b>predikatsfyllnad</b> (d.v.s. efter ordet det syftar på) böjs det inte alls i
        tyskan (till skillnad från i svenskan)
    </p>
    <div class="ruta quasi-p">
    <i>Das Kind ist krank.</i><br>Barnet är sjuk<b>t</b>.<br><br>
    <i>Die Kinder sind krank.</i><br>Barnen är sjuk<b>a</b>.
</div>

<p><br><br>Men står ett adjektiv som attribut (före sitt substantiv) så är det så att det <b>...</b></p>
</div>



<div class="grammatikparagrafbredd leftorient">

    <h4>böjs starkt</h4>

    <p>om adjektivet föregås av <b>inget bestämningsord</b> (ex. <i>Gut<b>er</b> Wein</i>)
    </p>
    <p>eller av <b> oböjt bestämningsord:</b></p>
    <p>ex: <i>ein, kein, mein, unser, etwas, viel, zwei, drei </i></p>

    <p class="mindre">eller av <b> vissa speciella plurala bestämningsord:</b></p>
    <p class="mindre">ex: <i>einige, viele</i></p>


    <p>Notera särskilt <b>oböjd form</b> av obestämd artikel (<i>ein</i>)</p>
    <p>Det finns inget som direkt avslöjar substantivets genus eller kasus i bestämningsordet. Det framkommer istället av adjektivet självt,
        när det böjs starkt.</p>



</div>

<p class="grammatikparagrafbredd leftorient">Adjektivets ändelser vid <b>stark</b> böjning:</p><br>


    <table class="">

        <tr class="leftorient">
            <td  class="ljusgra"></td>
            <td class="ljusgra">mask.</td>
            <td class="ljusgra">neutr.</td>
            <td class="ljusgra">fem.</td>
            <td class="ljusgra">plur.</td>
        </tr>

        <tr class="leftorient">
            <td class="ljusgra">nom.</td>
            <td class="rosa">-er</td>
            <td class="rosa">-es</td>
            <td class="rosa">-e</td>
            <td class="rosa">-e</td>
        </tr>

        <tr class="leftorient">
            <td class="ljusgra">ack.</td>
            <td class="rosa">-en</td>
            <td class="rosa">-es</td>
            <td class="rosa">-e</td>
            <td class="rosa">-e</td>
        </tr>

        <tr class="leftorient">
            <td class="ljusgra">dat.</td>
            <td class="rosa">-em</td>
            <td class="rosa">-em</td>
            <td class="rosa">-er</td>
            <td class="rosa">-en</td>
        </tr>

        <tr class="leftorient">
            <td class="ljusgra">gen.</td>
            <td class="vit">-en</td>
            <td class="vit">-en</td>
            <td class="rosa">-er</td>
            <td class="rosa">-er</td>
        </tr>


    </table><br>
    <p class="grammatikparagrafbredd leftorient">Som du ser är ändelserna vid stark böjning desamma som vid bestämd artikel, utom i genitiv i maskulinum och neutrum.
        </p>
<br>
        <div class="ruta">
    <p class="grammatikparagrafbredd leftorient"><i>Hast du mein schnell<b>es</b> Auto gesehen.</i></p>
    <p class="grammatikparagrafbredd leftorient"><i>Har du sett min snabba bil.</i></p>
</div>

<br>

    <div class="grammatikparagrafbredd leftorient">

        <h4>böjs svagt</h4>

        <p>om adjektivet föregås av <b>böjt bestämningsord</b>, d.v.s. något som avslöjar genus och kasus.
        </p>

        <p>Ex: <i>ein<b>en</b>, kein<b>em</b>, mein<b>er</b>, unser<b>em</b>, der, die, das, dem, jed<b>er</b>, welch<b>es</b>, all<b>e</b></i></p>
        <p>Notera särskilt de bestämda artiklarna!</p>

    </div>



    <p class="grammatikparagrafbredd leftorient">Adjektivets ändelser vid <b>svag</b> böjning:</p><br>


        <table class="">

            <tr class="leftorient">
                <td class="ljusgra"></td>
                <td class="ljusgra">mask.</td>
                <td class="ljusgra">neutr.</td>
                <td class="ljusgra">fem.</td>
                <td class="ljusgra">plur.</td>
            </tr>

            <tr class="leftorient">
                <td class="ljusgra">nom.</td>
                <td class="gul">-e</td>
                <td class="gul">-e</td>
                <td class="gul">-e</td>
                <td class="vit">-en</td>
            </tr>

            <tr class="leftorient">
                <td class="ljusgra">ack.</td>
                <td class="vit">-en</td>
                <td class="gul">-e</td>
                <td class="gul">-e</td>
                <td class="vit">-en</td>
            </tr>

            <tr class="leftorient">
                <td class="ljusgra">dat.</td>
                <td class="vit">-en</td>
                <td class="vit">-en</td>
                <td class="vit">-en</td>
                <td class="vit">-en</td>
            </tr>

            <tr class="leftorient">
                <td class="ljusgra">gen.</td>
                <td class="vit">-en</td>
                <td class="vit">-en</td>
                <td class="vit">-en</td>
                <td class="vit">-en</td>
            </tr>

        </table>
<br>
        <p class="grammatikparagrafbredd leftorient">Som du ser är ändelserna vid svag böjning antingen <b>-e</b> eller <b>-en</b>
             (kastrullregeln).</p>
             <br>
            <div class="ruta">
        <p class="grammatikparagrafbredd leftorient"><i>Lasst uns mit mein<b>em</b> schnell<b>en</b> Auto fahren!</i></p>
        <p class="grammatikparagrafbredd leftorient"><i>Låt oss åka med min snabba bil.</i></p>
    </div>
<br>

<br>


</div>


</template>

<script>
export default {
  name: 'Grammatik',
  props: {
    msg: String
},
metaInfo() {
    return {
        meta: [
            {
                vmid: "description",
                name: "description",
                content: "adjektiv stark svag böjning"
            }
        ]
    }
},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
